// extracted by mini-css-extract-plugin
export var brand = "_18-8";
export var compact = "_18-5";
export var extraSmall = "_18-6";
export var icon = "_18-0";
export var large = "_18-3";
export var light = "_18-1";
export var medium = "_18-4";
export var outline = "_18-a";
export var primaryDark = "_18-9";
export var primaryLight = "_18-7";
export var primaryModern = "_18-b";
export var success = "_18-2";